var COLLECTOR_BASE_URL = 'https://collector.mpianalytics.com';
var COLLECTOR_PATH = 'api/v1/track';
var CIS_BASE_URL = 'https://cis.mpianalytics.com';

export default {
  globalVarNames: [],
  collectorBaseUrl: COLLECTOR_BASE_URL,
  collectorPath: COLLECTOR_PATH,
  cisBaseUrl: CIS_BASE_URL,
  eventDebounce: 200,
  eventBatchSize: 10,
  environment: 'browser',
  useBeaconWhenAvailable: true,
  useExperimentation: true
};